module.exports = __webpack_public_path__ + "static/media/curso de voluntário.56eddb4e.jpeg";